import onWindowLoaded from 'components/utils/onWindowLoaded';

const gstarProductionInstanceId = '3d1210bf4ffd4e639a236cdc9d47c2b8';
const gstarStagingInstanceId = '226ddff9f7e4423285aa2d066ff10314';

const instanceIds = {
  b2c: {
    prd: gstarProductionInstanceId,
    acc: gstarStagingInstanceId,
  },
};

function initializeZowie() {
  const isStaging = AppSettings.environment !== 'prd';
  const envValue = isStaging ? 'acc' : 'prd';
  const instanceId = instanceIds?.[AppSettings.shopType]?.[envValue] || instanceIds.b2c?.[envValue];
  const locale = AppSettings.languageIso?.replace('_', '-');
  const origin = AppSettings.isBodyOnlyView ? 'app' : 'web';

  if (!instanceId) {
    console.error('Zowie instance id is not defined');
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  // eslint-disable-next-line
  script.text = `(function(d, s, id, cb) {var js = d.createElement(s);var n = d.createElement("div");n.id = id;if (js.readyState) {js.onreadystatechange = function() {if (js.readyState === "loaded" || js.readyState === "complete") {js.onreadystatechange = null; cb();}};} else {js.onload = function(){cb();};}js.src = "https://g-star.chat.getzowie.com/web/live-chat/chatbotize-entrypoint.min.js";document.body.appendChild(js);document.body.appendChild(n);})(document, "script", "chatbotize", function() {Zowie.init({instanceId: "${instanceId}",startOnOpen: true,headerMode: "white",metadata: {"locale": "${locale}","extraParams" : {"originOfChat" : "${origin}"}}});});`;
  document.body.appendChild(script);
}

if ((AppState.hasMarketingConsent && AppState.hasAnalyticsConsent) || AppSettings.isBodyOnlyView) {
  onWindowLoaded(initializeZowie, window);
}

window.initializeZowie = initializeZowie;
